var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{staticClass:"common-el-tabs",attrs:{"type":"card"}},[_c('el-tab-pane',{attrs:{"label":"AT"}},[_c('comp-club-at',{staticClass:"common-el-tab-flex"})],1),_c('el-tab-pane',{attrs:{"label":"MT"}},[_c('comp-club-mt',{staticClass:"common-el-tab-flex"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }